export default "__VITE_ASSET__BuD3fRiS__"